import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarContaBancoModel } from "../models/contaBanco/buscarContaBancoModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarContaBanco, setModalDeletarContaBanco } from "../redux/slices/contaBanco/contaBancoSlice";

export const cadastrarContaBanco = createAsyncThunk("/ContaBanco/CadastrarContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ContaBanco/CadastrarContaBanco/", payload.value);
    toastSucess("Conta do banco cadastrado com sucesso");
    dispatch(setModalCadastrarContaBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarContaBanco = createAsyncThunk("/ContaBanco/BuscarContaBanco", async (args: BuscarContaBancoModel) => {
  try {
    const data = await api.get("/ContaBanco/BuscarContaBanco", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarContaBanco = createAsyncThunk("/ContaBanco/AtualizarContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ContaBanco/AtualizarContaBanco", payload.value);
    toastSucess("Conta do banco atualizada com sucesso");
    dispatch(setModalCadastrarContaBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarContaBancoAtivo = createAsyncThunk("/ContaBanco/AtualizarContaBancoAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ContaBanco/AtualizarContaBancoAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status de ativo da conta do banco atualizada com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarContaBanco = createAsyncThunk("/ContaBanco/DeletarContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/ContaBanco/DeletarContaBanco", {
      params: { id: payload.value },
    });
    toastSucess("Conta do banco removida com sucesso");
    dispatch(setModalDeletarContaBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
